export const shouldFirePixelEvents = (): boolean => {
  const hostname = window.location.hostname;

  if (hostname.startsWith("internal.")) return false;
  if (hostname.startsWith("staging.")) return true;
  if (hostname.startsWith("app.")) return true;

  return false;
};
